import { useNavigate } from "react-router-dom";
import backArrow from "../../assets/images/greenbackarrow.svg";
import useLanguageTranslate from "../../hooks/useLanguageTranslate";
import ChangePassword from "../profileSettings/changePassword";

/**
 * Change password (mobile). Reached from Profile and from Security, so Back
 * returns to wherever the customer came from (Profile when opened directly);
 * a successful change returns there too, with the success toast.
 */
const MobileChangePasswordPage = () => {
  const navigate = useNavigate();
  const translate = useLanguageTranslate();

  const goBack = () => {
    if (window.history.state?.idx > 0) {
      navigate(-1);
    } else {
      navigate("/profile-details", { replace: true });
    }
  };

  return (
    <div className="mx-auto w-[500px] max-w-full px-5 pt-[19px] pb-12">
      <button
        type="button"
        aria-label={translate("Back", "رجوع")}
        onClick={goBack}
        className="-ms-1 flex h-10 w-10 items-center justify-center rounded-full transition-transform duration-150 ease-out active:scale-[0.94]"
      >
        <img src={backArrow} alt="" className="h-10 w-10 rtl:rotate-180" />
      </button>

      <div className="mt-5">
        <h1 className="text-[#1A2024] text-2xl font-semibold leading-8 tracking-[-0.24px]">
          {translate("Change password", "تغيير كلمة المرور")}
        </h1>
        <p className="mt-1 text-[#5B6871] text-base leading-6">
          {translate(
            "Enter your current password, then choose a new one.",
            "أدخل كلمة المرور الحالية، ثم اختر كلمة مرور جديدة."
          )}
        </p>
      </div>

      <ChangePassword pinActionOnMobile onSuccess={goBack} />
    </div>
  );
};

export default MobileChangePasswordPage;
